import { Injectable } from "@angular/core";
import { AppService } from "@app/core/services/base.service";
import { S1HttpClientService } from "./s1-http-client.service";
import { environment } from "src/environments/environment";

@Injectable()
export class S1ZipService {

  pathZipCodes = 'autocompile/zip';

  constructor(
    private  appService: AppService,
    private s1HttpService: S1HttpClientService
  ) { }

  getZipCodes(zip: string) {
    return this.s1HttpService.get(`${this.pathZipCodes}/${zip}`, false, environment.restBaseUrlQBS);
  }

}
